import { Box, Button, Popover, Typography } from '@mui/material';
import type { IAssignedUserModel } from '../models/AssignedUserModel';
import Avatar from './comments/avatar';

type AssignedUserPreviewPopoverProps = {
  user: IAssignedUserModel;
  anchorEl: HTMLElement;
  onClose: () => void;
};

export const AssignedUserPreviewPopover = ({
  user,
  anchorEl,
  onClose,
}: AssignedUserPreviewPopoverProps) => {
  const employeeProfileUrl = `/management/employees/employees/${user.id}`;

  return (
    <Popover
      open
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      slotProps={{ paper: { sx: { p: 2, minWidth: 250 } } }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: 1,
        }}
      >
        <Avatar
          className="kanban-card__avatar kanban-card__profile-preview-avatar"
          initials={user.initials ?? ''}
          relationId={user.id}
          colorKey={user.fullName}
          hasProfilePhoto={user.hasProfilePhoto}
          profilePhotoUrl={user.profilePhotoUrl ?? undefined}
        />
        <Typography variant="h6" fontWeight={600} lineHeight={1.2}>
          {user.fullName}
        </Typography>
        <Button
          variant="outlined"
          size="small"
          onClick={() => {
            window.location.href = employeeProfileUrl;
          }}
        >
          View profile
        </Button>
      </Box>
    </Popover>
  );
};
